import type { BibliographyEntry } from "@/types/bibliography";

// Dynamic import of all bibliography JSON files
const dataModules = import.meta.glob<{ default: BibliographyEntry }>(
  "/src/data/bibliography/*.json",
  { eager: true }
);

// Dynamic import of all bibliography Markdown content
const contentModules = import.meta.glob<string>(
  "/src/content/bibliography/*.md",
  { eager: true, query: "?raw", import: "default" }
);

// Build lookup maps
export const bibliographyData: Record<string, BibliographyEntry> = {};
export const bibliographyContent: Record<string, string> = {};

// Parse JSON modules
for (const path in dataModules) {
  const match = path.match(/\/([^/]+)\.json$/);
  if (match) {
    const refId = match[1];
    bibliographyData[refId] = dataModules[path].default;
  }
}

// Parse Markdown modules
for (const path in contentModules) {
  const match = path.match(/\/([^/]+)\.md$/);
  if (match) {
    const refId = match[1];
    bibliographyContent[refId] = contentModules[path];
  }
}

// Get all entries sorted by first author
export const getBibliographyList = (): BibliographyEntry[] => {
  return Object.values(bibliographyData).sort((a, b) => {
    const authorA = a.authors[0] || "";
    const authorB = b.authors[0] || "";
    return authorA.localeCompare(authorB, "de");
  });
};

// Get slugs for SSG
export const getBibliographySlugs = (): string[] => {
  return Object.keys(bibliographyData);
};
